import { createIcon } from '@chakra-ui/icons';

export const ImportedContent = createIcon({
  displayName: 'ImportedContent',
  viewBox: '0 0 24 23',
  d: 'M19.4591 0L24 6.19091V22.2545H0V6.19091L4.54091 0H19.4591ZM21.8182 20.0727V8.29091H14.8364V6.10909H21.2318L18.3545 2.18182H13.0909V8.29091H10.9091V2.18182H5.64545L2.76818 6.10909H9.16364V8.29091H2.18182V20.0727H21.8182Z',
});
